import Component_AssetManager_cfdf2e4aaec4a9c39cde478b79f25251 from "../../../../content/examples/models/asset-manager/AssetManager";
import Devtool_AssetManager_cfdf2e4aaec4a9c39cde478b79f25251 from "!!@devtool/loader!../../../../content/examples/models/asset-manager/AssetManager";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_AssetManager_cfdf2e4aaec4a9c39cde478b79f25251,
  Devtool_AssetManager_cfdf2e4aaec4a9c39cde478b79f25251,
  DevTool,
  React
};